import { useLocalstorageState } from "Hooks/useLocalstorageState";
import { useCallback } from "react";

const DISMISS_KEY = "mobile-dashboard-notice-dismissed";

export function useMobileDashboardNotice(isMobile: boolean) {
  const [dismissed, setDismissed, isLoaded] = useLocalstorageState(
    DISMISS_KEY,
    false,
  );

  const shouldShow = isMobile && isLoaded && !dismissed;

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, [setDismissed]);

  return { shouldShow, dismiss };
}
